import { setTimeout } from 'core-js';
import store from '../../store/index';
import tools from './tools';

export default {
  socketList: [
    {
      port: 33333,
      cname: '服务一状态',
      ename: 'Service 1',
      socket: '',
      lock: false,
      close: false,
      readyState: '',
      loading: false,
      icon: 's-tools',
    },
    {
      port: 33334,
      cname: '服务二状态',
      ename: 'Service 2',
      socket: '',
      lock: false,
      close: false,
      readyState: '',
      loading: false,
      icon: 's-tools',
    },
    {
      port: 33335,
      cname: '软件模组状态',
      ename: 'Software Model',
      socket: '',
      lock: false,
      close: false,
      readyState: '',
      loading: false,
      icon: 's-goods',
    },
    {
      port: 33336,
      cname: '信息模组状态',
      ename: 'Info Model',
      socket: '',
      lock: false,
      close: false,
      readyState: '',
      loading: false,
      icon: 's-data',
    },
  ],

  async initSocket(index) {
    if (index > 3 || index < 0) return 'Wrong Index';
    const { readyState } = this.socketList[index].socket;
    this.socketList[index].close = false;
    if (readyState === 1) return 'Socket Ready';
    this.socketList[index].loading = true;
    this.socketList[index].socket = await new WebSocket(`ws://localhost:${this.socketList[index].port}`);
    this.socketList[index].socket.onerror = () => {
      console.log(`> onerror called at ${index}`);
      this.reConnect(index);
    };
    this.socketList[index].socket.onopen = () => {
      this.socketList[index].readyState = this.socketList[index].socket.readyState;
      this.socketList[index].loading = false;
      store.commit('setSocketStatus', this.socketList);
      console.log(`> onopen called at ${index}`);
    };
    this.socketList[index].socket.onclose = () => {
      console.log(`> onclose called at ${index}`);
    };
    for (let i = 0; i < 20; i += 1) {
      // eslint-disable-next-line no-await-in-loop
      await tools.sleep(100);
      if (this.socketList[index].socket !== '' && this.socketList[index].readyState === 1) {
        return 'Init Success';
      }
    }
    return 'Socket Init';
  },
  closeSocket(index) {
    try {
      this.socketList[index].readyState = 3;
      this.socketList[index].close = true;
      this.socketList[index].socket.close();
      this.socketList[index].loading = false;
    } catch (error) {
      // console.log('> closeSocket', error);
    }
    return this.socketList[index].lock;
  },
  closeAllSocket() {
    localStorage.setItem('beforeDestroy', 'closeAllSocket Run!');
    try {
      this.socket.closeSocket(0);
      this.socket.closeSocket(1);
      if (store.state.isNewService) {
        this.socket.closeSocket(2);
        this.socket.closeSocket(3);
      }
    } catch (error) {
      // console.log('> closeAllSocket', error);
    }
  },
  reConnect(index) {
    if (localStorage.getItem('iDesk-init') === 'initing') {
      this.closeSocket(index);
      return;
    }
    if (store.state.socketIniting) return;
    if (this.socketList[index].close) return;
    // console.log(`reConnect called > ${index}`, this.socketList[index].lock);
    if (this.socketList[index].lock) return;
    this.socketList[index].lock = true;
    this.socketList[index].readyState = 3;
    store.commit('setSocketStatus', this.socketList);
    setTimeout(() => {
      this.socketList[index].lock = false;
      this.initSocket(index, () => {});
    }, 2000);
  },
  sendSocket(index, params, callback) {
    if (this.socketList[index].readyState === 1) {
      this.socketList[index].socket.send(params);
      this.socketList[index].socket.onmessage = (msg) => {
        const result = msg.data.replace('\r\n', '');
        const idx = result.lastIndexOf('Responsed:');
        const datas = result.substring(idx + 10, result.length).trim();
        if (!datas.includes('%","error":"","type":"Download"')) {
          store.commit('setDebugInfos', ['socket res', datas]);
        }
        try {
          callback(store.state.isNewService ? datas : JSON.parse(datas));
        } catch (error) {
          console.log('>socket error: ', datas, error);
        }
      };
    } else {
      callback('failConnect');
    }
  },
  initSocketEntity(index) {
    this.socketList[index].loading = true;
    this.socketList[index].socket = new WebSocket(`ws://localhost:${this.socketList[index].port}`);
    return this.socketList[index].socket;
  },
  setSocketCalled(index) {
    this.socketList[index].readyState = this.socketList[index].socket.readyState;
    this.socketList[index].loading = false;
    store.commit('setSocketStatus', this.socketList);
    console.log(`> onopen called at ${index}`);
  },
};
